import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Notifications_DatasourceService } from './Notifications.datasource.index';
import { Inventory_DatasourceService } from './Inventory.datasource.index';
import { FootPrintApiManager_DatasourceService } from './FootPrintApiManager.datasource.index';

import { app_ds_get_inventory_by_project_lookupService } from './app.datasource.index';
import { app_ds_get_warehousesService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.Invoices = this.injector.get(Invoices_DatasourceService);
    this.Notifications = this.injector.get(Notifications_DatasourceService);
    this.Inventory = this.injector.get(Inventory_DatasourceService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public Invoices: Invoices_DatasourceService;
    public Notifications: Notifications_DatasourceService;
    public Inventory: Inventory_DatasourceService;
    public FootPrintApiManager: FootPrintApiManager_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_get_inventory_by_project_lookup: app_ds_get_inventory_by_project_lookupService;
  public get ds_get_inventory_by_project_lookup(): app_ds_get_inventory_by_project_lookupService {
    if(!this._ds_get_inventory_by_project_lookup) {
      this._ds_get_inventory_by_project_lookup = this.injector.get(app_ds_get_inventory_by_project_lookupService);
    }
    return this._ds_get_inventory_by_project_lookup;
  }
  private _ds_get_warehouses: app_ds_get_warehousesService;
  public get ds_get_warehouses(): app_ds_get_warehousesService {
    if(!this._ds_get_warehouses) {
      this._ds_get_warehouses = this.injector.get(app_ds_get_warehousesService);
    }
    return this._ds_get_warehouses;
  }
}

